<template>
    <div class="alHeader">
        <div class="header" v-text="title"></div>
    </div><!-- alHeader结束 -->
</template>

<script>
export default {
    name: 'alHeader',
    props: {
        title: String
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    .alHeader {
        padding-top: 45px;
    }
    .header {
        position: fixed;
        left: 0;
        top: 0;
        width: 100%;
        text-align: center;
        font-size: 14px;
        padding: 16px;
        background-color: #3d4851;
        color: #fff;
    }
</style>
